import { ZinsserView } from './ZinsserView'

/**
 * ZinsserPage - Main zinsser screen.
 *
 * Features a collapsible session sidebar on the left, chat in the center,
 * and document panel on the right.
 */
export function ZinsserPage() {
  return <ZinsserView />
}
